export default {"src":"/_next/static/media/illustration-exclamation-paw.3318500d.svg","height":75,"width":82};